import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createTypeTransactionApi } from "../../services/type-transaction/create.type.transaction.api";

export const useCreateTypeTransactionApi = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (createInfo: any) => createTypeTransactionApi(createInfo),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["type-transaction"],
      });
    },
  });
};
